import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from 'react';
import * as fa from '@personly/libs-fontawesome';
const FontAwesomeIcon = lazy(() => import('@fortawesome/react-fontawesome').then((m) => ({
    default: m.FontAwesomeIcon,
})));
const Icon = ({ fixedWidth = false, icon: name, size, type, spin = false, }) => (_jsx(Suspense, { fallback: _jsx("div", { className: `fa-${size}`, children: "\u00A0" }), children: _jsx(FontAwesomeIcon, { icon: fa[type][name], fixedWidth: fixedWidth, spin: spin, size: size }) }));
export default Icon;
